<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="7" width="8" height="10" rx="1" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <rect x="13" y="3" width="8" height="14" rx="1" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round"/>
    <path d="M3 8L8 5L13 9L18 6L21 8" stroke="#00B9FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'IconSkillith'
}
</script>
